import { bus } from '../engine/EventBus';
import { save } from '../engine/SaveSystem';
import {
  SKIN_COLORS,
  HAIR_COLORS,
  OUTFIT_COLORS,
  WING_COLORS,
  type CharacterConfig,
} from '../data/characters';

export class CustomizationPanel {
  readonly el: HTMLElement;
  onConfirm?: () => void;
  onCancel?: () => void;

  constructor(root: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'overlay hidden';
    this.render();
    root.appendChild(this.el);
  }

  show(allowCancel = false): void {
    this.render(allowCancel);
    this.el.classList.remove('hidden');
  }
  hide(): void { this.el.classList.add('hidden'); }

  private render(allowCancel = false): void {
    const c = save.data.character;
    this.el.innerHTML = `
      <div class="panel">
        <h1 style="font-size:32px">Your Character</h1>
        <p class="subtitle">Pick who you are today. You can change later.</p>

        <div class="type-toggle" data-row="type">
          <button data-type="fairy" class="${c.type === 'fairy' ? 'active' : ''}">🧚 Fairy</button>
          <button data-type="elf" class="${c.type === 'elf' ? 'active' : ''}">🧝 Elf</button>
        </div>

        ${this.swatchRow('Skin', 'skin', SKIN_COLORS, c.skin)}
        ${this.swatchRow('Hair', 'hair', HAIR_COLORS, c.hair)}
        ${this.swatchRow('Outfit', 'outfit', OUTFIT_COLORS, c.outfit)}
        ${this.swatchRow('Wings', 'wings', WING_COLORS, c.wings)}

        <div class="menu-buttons" style="margin-top:18px; flex-direction:row; justify-content:center;">
          ${allowCancel ? '<button class="btn ghost" data-action="cancel">Cancel</button>' : ''}
          <button class="btn" data-action="confirm">Looks perfect ✨</button>
        </div>
      </div>
    `;
    this.wire();
  }

  private swatchRow(label: string, slot: keyof CharacterConfig, colors: readonly string[], selected: string): string {
    const swatches = colors.map((col) => (
      `<div class="swatch ${col.toLowerCase() === selected.toLowerCase() ? 'active' : ''}" data-slot="${slot}" data-color="${col}" style="background:${col}"></div>`
    )).join('');
    return `<div class="custom-row"><label>${label}</label><div class="swatches">${swatches}</div></div>`;
  }

  private wire(): void {
    this.el.querySelectorAll('[data-type]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const t = (btn as HTMLElement).dataset.type as 'fairy' | 'elf';
        save.data.character.type = t;
        bus.emit('character:changed', {});
        bus.emit('save:dirty', {});
        this.render(true);
      });
    });
    this.el.querySelectorAll('.swatch').forEach((sw) => {
      sw.addEventListener('click', () => {
        const slot = (sw as HTMLElement).dataset.slot as keyof CharacterConfig;
        const color = (sw as HTMLElement).dataset.color!;
        (save.data.character[slot] as string) = color;
        bus.emit('character:changed', {});
        bus.emit('save:dirty', {});
        this.render(true);
      });
    });
    const confirm = this.el.querySelector('[data-action="confirm"]') as HTMLButtonElement | null;
    confirm?.addEventListener('click', () => this.onConfirm?.());
    const cancel = this.el.querySelector('[data-action="cancel"]') as HTMLButtonElement | null;
    cancel?.addEventListener('click', () => this.onCancel?.());
  }
}
